import { CONFIG } from '../utils/config';
import { apiSlice } from './apiSlice';

// API Central (apic) page CMS content API
// URL base varies per environment: see REACT_APP_CMS_API_URL in each .env file.
// Backend returns { success, data: { sections: [{ component, data }] } }
export const apicPageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getApicContent: builder.query({
      query: () => ({
        url: `${CONFIG.CMS_API_URL}/apic`,
        method: 'GET',
        headers: { source: 'adp.com' },
      }),
      providesTags: ['ApicContent'],
      transformResponse: (response) => response?.data ?? null,
      transformErrorResponse: (response) => {
        console.error('Failed to fetch apic content:', response?.data || 'API Error');
        return null;
      },
    }),
  }),
});

export const { useGetApicContentQuery } = apicPageApi;
